import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectKey: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-key-field.project-key',
		defaultMessage: 'Key',
		description: 'Field header for the project key field',
	},
	projectKeyDescription: {
		id: 'project-create-importer-upload-flow.project-create-screen.project-key-field.project-key-description',
		defaultMessage:
			'Choose a descriptive prefix for your project’s issue keys to recognize work from this project. <link>Learn more</link>',
		description: 'Description inside project key field tooltip',
	},
});
